import NitroEventHelper from '../helper/nitro-event-helper.js';
import TrackingEventFactory from './edit-layer-tracking-event-factory.js';
import ModelContainer from './model-container.js';

export default async function sendNitroEvent(selectedItem, selectedItemOption, oldQuantity, newQuantity) {
    if (oldQuantity > newQuantity) {
        await NitroEventHelper.trigger(
            NitroEventHelper.EventType.REMOVE_FROM_CART,
            TrackingEventFactory.createChangeCartFromEditLayerEvent(
                selectedItem,
                selectedItemOption,
                oldQuantity - newQuantity,
                ModelContainer.get('pageViewId')
            )
        );
    } else if (oldQuantity < newQuantity) {
        await NitroEventHelper.trigger(
            NitroEventHelper.EventType.ADD_TO_CART,
            TrackingEventFactory.createChangeCartFromEditLayerEvent(
                selectedItem,
                selectedItemOption,
                newQuantity - oldQuantity,
                ModelContainer.get('pageViewId')
            )
        );
    }
}